import { render, staticRenderFns } from "./Sucursal.vue?vue&type=template&id=2325b1b9&scoped=true"
import script from "./Sucursal.vue?vue&type=script&lang=js"
export * from "./Sucursal.vue?vue&type=script&lang=js"
import style0 from "./Sucursal.vue?vue&type=style&index=0&id=2325b1b9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325b1b9",
  null
  
)

export default component.exports